import { Component, Input, OnInit } from '@angular/core';
import { CustomProductsService } from 'src/app/modules/custom-landing/custom-products/custom-products.service';
import { RouterLink } from '@angular/router';
import { NgFor, NgIf } from '@angular/common';

@Component({
    selector: 'app-inventory-breadcrumb',
    templateUrl: './inventory-breadcrumb.component.html',
    styleUrls: ['./inventory-breadcrumb.component.scss'],
    imports: [RouterLink, NgFor, NgIf]
})
export class InventoryBreadcrumbComponent implements OnInit {
  @Input() pageTitle: string;
  @Input() navigationData: string;
  constructor(private customProductService: CustomProductsService) { }

  ngOnInit(): void {
  }

  homeLinkClick(value): any{
    this.customProductService.getHomeLinkActive(value);
  }
}
